import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum ID_PUBBLICATIONS {
  ID_PUBBLICATION_SINGLE = '1',
  ID_PUBBLICATION_OCCURRED = '2',
  ID_PUBBLICATION_OMISSION = '3',
}

const publications = Object.freeze([
  {
    id: ID_PUBBLICATIONS.ID_PUBBLICATION_SINGLE,
    value: 'Pubblicazione in un solo comune o consolato',
  },
  {
    id: ID_PUBBLICATIONS.ID_PUBBLICATION_OCCURRED,
    value: 'Pubblicazioni avvenuta su piu comuni o consolati',
  },
  {
    id: ID_PUBBLICATIONS.ID_PUBBLICATION_OMISSION,
    value: 'Omissione di pubblicazione',
  },
]);

interface ListPublicationProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  label?: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  isSmallSize?: boolean;
}

const ListPublicationComponent = ({
  disabled,
  required,
  onChange,
  value,
  label = 'Pubblicazione',
  error,
  isSmallSize = false,
}: ListPublicationProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="publication-label">
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="publication-label"
        id="publication"
        name="publication"
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {publications.map((publication: ItemVM) => (
          <MenuItem key={publication.id} value={publication.id}>
            {publication.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListPublicationComponent.displayName = 'List Publication component';

const ListPublication = memo(ListPublicationComponent);

export default ListPublication as typeof ListPublicationComponent;
